import {get, post, del, patch} from "../api"
import * as url from "../url"

const apiGetSectionsList = data => {
  return get(url.API_SECTIONS, data.history)
}

const apiPostSectionsNew = data => {
  return post(url.API_SECTIONS, data.history, data.values)
}

const apiPatchSectionsEdit = data => {
  return patch(url.API_SECTIONS + data.id + "/", data.history, data.values)
}

const apiDeleteSectionsDelete = data => {
  return del(url.API_SECTIONS + data.id + "/", data.history)
}

const apiGetSectionsCompaniesList = data => {
  return get(url.API_COMPANIES + "select/", data.history)
}

export {
  apiGetSectionsList,
  apiPostSectionsNew,
  apiPatchSectionsEdit,
  apiDeleteSectionsDelete,
  apiGetSectionsCompaniesList,
}
